import WebGLColor, {default as Color} from '../Color';
import Shape from './Shape';
import DrawInfo from '../DrawInfo';
import Matrix4 from '../../../../../foundation/algebra/linear/Matrix4';

abstract class CompositeShape implements Shape {

	/*
	 * Command methods
	 */

	public rotateX (angle: number) {
		this.getComponents().forEach(component => component.rotateX(angle));
		return this;
	}

	public rotateY (angle: number) {
		this.getComponents().forEach(component => component.rotateY(angle));
		return this;
	}

	public rotateZ (angle: number) {
		this.getComponents().forEach(component => component.rotateZ(angle));
		return this;
	}

	public scale (x: number, y?: number, z?: number) {
		if (y === undefined || z === undefined) {
			this.getComponents().forEach(component => component.scale(x));
		} else {
			this.getComponents().forEach(component => component.scale(x, y, z));
		}

		return this;
	}

	public setColor (color: WebGLColor | null) {
		this.getComponents().forEach(component => component.setColor(color));
		return this;
	}

	public translate (x: number, y: number, z: number) {
		this.getComponents().forEach(component => component.translate(x, y, z));
		return this;
	}

	public setTransformationMatrix (matrix: Matrix4) {
		this.getComponents().forEach(component => component.setTransformationMatrix);
		return this;
	}

	/*
	 * Query methods
	 */

	public abstract copy(): CompositeShape;

	public getDrawInfo (defaultColor: Color) {
		return this.getComponents().reduce((drawInfo: DrawInfo[], component) => drawInfo.concat(component.getDrawInfo(defaultColor)), []);
	}

	/*
	 * Protected methods
	 */

	protected abstract getComponents (): Shape[];
}

export default CompositeShape;



// WEBPACK FOOTER //
// ./code/project/pages/components/webGL/shapes/CompositeShape.ts